<template>
  <p class="truncate text-sm font-semibold">{{ title }}</p>
  <p v-if="isInProgress" class="text-sm text-gray-600">
    <span class="text-warning-700 font-medium">{{ progressLabel }}</span>
  </p>
  <p v-else-if="notification.status === NOTIFICATION_STATUS.SUCCESS" class="text-sm text-gray-600">
    Import completed
  </p>
  <p v-else-if="notification.status === NOTIFICATION_STATUS.ERROR" class="text-sm text-gray-600">
    Import failed: {{ notification.runArgs?.error || 'Please try again' }}
  </p>
</template>

<script setup>
import { computed } from 'vue'
import { NOTIFICATION_STATUS } from '@/lib/NotificationConstants'

const props = defineProps({
  notification: {
    type: Object,
    required: true
  }
})

const isInProgress = computed(() => props.notification.status === NOTIFICATION_STATUS.IN_PROGRESS)

// `source` names where the data comes from (e.g. "Dayforce"); omitted for plain uploads.
const source = computed(() => props.notification.runArgs?.source)

const title = computed(() => {
  const { boardName, trigger } = props.notification.runArgs ?? {}
  const noun = source.value ? `${source.value} import` : 'Data import'
  const prefix = trigger === 'auto_sync' ? `Scheduled ${noun}` : noun
  return boardName ? `${prefix} - ${boardName}` : prefix
})

const progressLabel = computed(() =>
  source.value ? `Importing data from ${source.value}...` : 'Importing data...'
)
</script>
